import { render, staticRenderFns } from "./CustomizeInvitation.vue?vue&type=template&id=2dac2a13&scoped=true&"
import script from "./CustomizeInvitation.vue?vue&type=script&lang=js&"
export * from "./CustomizeInvitation.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeInvitation.vue?vue&type=style&index=0&id=2dac2a13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dac2a13",
  null
  
)

export default component.exports